import Image from "next/image";
import clxs from "clsx";

interface AvatarProps {
	src: string;
	size?: "sm" | "md" | "lg";
}
export default function Avatar(props: AvatarProps) {
	const sizeCn = () => {
		switch (props.size) {
			case "sm":
				return "w-6 h-6";
			case "md":
				return "w-8 h-8";
			case "lg":
				return "w-10 h-10";
			default:
				return "w-8 h-8";
		}
	};
	return (
		<div className={clxs("relative rounded-full", sizeCn())}>
			<Image src={props.src} alt="avatar" className="object-cover rounded-full" layout="fill" />
		</div>
	);
}
